import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function CareerDetails3() {
  return (
    <>
      <Header />

      <section className="container" style={{ paddingTop: "120px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginBottom: "40px",
          }}
        >
          <div
            style={{
              width: "300px",
              height: "1px",
              backgroundColor: "#dcdcdc",
            }}
          ></div>

          <p
            style={{
              margin: 0,
              fontSize: "16px",
              color: "#888",
            }}
          >
            <a
              href="/"
              style={{
                color: "#111",
                textDecoration: "none",
              }}
            >
              Home
            </a>
            {" / "}
            <a
              href="/careers"
              style={{
                color: "#111",
                textDecoration: "none",
              }}
            >
              Careers
            </a>
            {" / "}
            Business Development Executive Intern
          </p>
        </div>

        <h1
          style={{
            textAlign: "center",
            fontSize: "64px",
            lineHeight: "1.1",
            marginBottom: "80px",
          }}
        >
          <span style={{ fontWeight: "600" }}>
            Business Development
          </span>{" "}
           <br />
          <span style={{ fontWeight: "300" }}>
            Executive Intern
          </span>
        </h1>

        <div style={{ maxWidth: "720px", margin: "0 auto" }}>

          <p style={{ marginBottom: "15px", fontSize: "16px" }}>
            <strong>Position:</strong> Business Development Executive Intern
          </p>

          <p style={{ marginBottom: "15px", fontSize: "16px" }}>
            <strong>Job ID:</strong> BNWJB20260155
          </p>

          <p style={{ marginBottom: "15px", fontSize: "16px" }}>
            <strong>Employment Type:</strong> Internship (Remote)
          </p>

          <p style={{ marginBottom: "40px", fontSize: "16px" }}>
            <strong>Experience:</strong> Freshers
          </p>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#777",
              marginBottom: "25px",
            }}
          >
            BlackWhite Creative Services is looking for enthusiastic and
            driven Business Development Executives to learn the art of
            growing a creative agency. The internship provides practical
            exposure to client acquisition, lead generation, business
            communication, and service-based sales in the creative and
            marketing industry.
          </p>

          <h4 style={{ marginBottom: "25px" }}>
            Role Overview
          </h4>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#777",
              marginBottom: "40px",
            }}
          >
            As a Business Development Executive Intern, you will support
            the team in identifying potential clients, building
            relationships, and contributing to the growth of the
            company’s marketing and creative services. You will gain
            practical experience in lead generation, pitching services,
            market research, and client communication while understanding
            how creative agencies operate in real business environments.
          </p>

          <h4 style={{ marginBottom: "25px" }}>
            Key Responsibilities
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "16px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>
              Assist in identifying and reaching out to potential clients
              through email, LinkedIn, and other platforms
            </li>
            <li>
              Research businesses and brands that may require marketing,
              branding, or creative services
            </li>
            <li>
              Support the preparation of pitch decks, proposals, and
              presentations
            </li>
            <li>
              Maintain and update lead databases and client communication
              records
            </li>
            <li>
              Coordinate with the creative and marketing teams to
              understand service offerings
            </li>
            <li>
              Follow up with leads and assist in scheduling client
              meetings
            </li>
            <li>
              Contribute ideas for improving outreach strategies and
              business growth
            </li>
            <li>
              Stay updated on market trends, competitors, and industry
              insights
            </li>
          </ul>

          <h4 style={{ marginBottom: "25px" }}>
            Qualifications & Skills
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "16px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>Good communication and interpersonal skills</li>
            <li>
              Strong interest in sales, marketing, branding, or business
              development
            </li>
            <li>
              Basic understanding of digital marketing and branding
              concepts is a plus
            </li>
            <li>
              Confidence in written and verbal communication
            </li>
            <li>
              Familiarity with LinkedIn, Google Workspace, MS Office, or
              CRM tools is an added advantage
            </li>
            <li>
              Ability to work independently and collaboratively in a
              remote environment
            </li>
            <li>
              Strong organizational skills and attention to detail
            </li>
            <li>
              Pursuing or recently completed a degree/diploma in
              Business, Marketing, Management, or a related field
            </li>
          </ul>

          <h4 style={{ marginBottom: "25px" }}>
            What You'll Gain
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "16px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>
              Practical exposure to business development in a creative
              agency environment
            </li>
            <li>
              Hands-on experience in client communication and lead
              generation
            </li>
            <li>
              Mentorship and guidance from experienced professionals
            </li>
            <li>
              Understanding of business, marketing, and creative service
              workflows
            </li>
            <li>
              Opportunity to build professional communication and
              networking skills
            </li>
            <li>
              Experience Letter and Recommendation Letter upon successful
              completion of the internship
            </li>
          </ul>

          <h4 style={{ marginBottom: "25px" }}>
            Internship Details
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "16px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>Work Mode: Remote</li>
            <li>Duration: 6 Months</li>
            <li>
              Working Hours: Flexible schedule with an expected
              commitment of 20-25 hours per week
            </li>
            <li>
              Availability for team meetings and follow-ups during
              working days is preferred
            </li>
            <li>
              Stipend: Optional. This internship is designed as a
              learning-focused opportunity offering hands-on industry
              exposure and real-world business development experience.
            </li>
          </ul>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#777",
              marginBottom: "40px",
            }}
          >
            If you are someone who is proactive, confident, and eager to
            grow in the field of marketing and business development, we
            would love to have you on board.
          </p>

<hr
  style={{
    border: "none",
    borderTop: "1px solid #ddd",
    marginTop: "60px",
    marginBottom: "30px",
  }}
/>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "50px",
  }}
>
  <Link
    to="/apply-job"
    style={{
      textDecoration: "none",
      color: "#111",
      fontSize: "16px",
      fontWeight: "500",
    }}
  >
    Apply
  </Link>

  <Link
    to="/apply-job"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "22px",
    }}
  >
    →
  </Link>
</div>

        </div>
      </section>

      <Footer />
    </>
  );
}

export default CareerDetails3;